import React from "react";
import "./index.scss";

const ProblemSolutionCard = ({ lead }) => {
  const creditor = lead?.lawsuitDetails?.["creditor (plaintiff)"] || "";
  const heading = "Good news! We can help.";
  const subHeading =
    "You must act now to protect your paycheck and bank account. You are up against a deadline.";
  return (
    <>
      <h2 className="prob_sol__heading">{heading}</h2>
      <h2 className="prob_sol__subheading">{subHeading}</h2>
      <div className="card-row">
        <div className="card problem-card">
          <div className="card-header red-header">Your Problem</div>
          <div className="card-body">
            {creditor} is trying to get a court judgment to take your money by
            force.
          </div>
        </div>

        <div className="card solution-card">
          <div className="card-header green-header">Our Solution</div>
          <div className="card-body">
            As your lawyers we will protect you, buy you time (6 to 18 months)
            and settle for as little money as we can - save you money with
            affordable terms.
          </div>
        </div>
      </div>
    </>
  );
};

export default ProblemSolutionCard;
